import { Download } from 'lucide-react'

const MidDayResetTab = ({ midDayReset, exportingCSV, onExportCSV }) => {
  if (!midDayReset) return null

  return (
    <div className="overflow-x-auto">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold text-white">
          Mid Day Reset Signups ({midDayReset.length})
        </h3>
        <div className="flex items-center gap-4">
          <button
            onClick={onExportCSV}
            disabled={exportingCSV}
            className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            <Download className="w-4 h-4" />
            {exportingCSV ? 'Exporting...' : 'Export Session Data CSV'}
          </button>
          <div className="bg-gradient-to-br from-teal-500/20 to-cyan-500/20 rounded-xl px-4 py-2 text-center border border-teal-500/30">
            <span className="text-2xl font-bold text-teal-300">
              {midDayReset.length}
            </span>
            <span className="text-sm text-gray-400 ml-2">Total Signups</span>
          </div>
        </div>
      </div>
      <table className="min-w-full divide-y divide-white/10">
        <thead>
          <tr>
            {['Name', 'Email', 'Phone', 'Date'].map(header => (
              <th key={header} className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/10">
          {midDayReset.map((signup) => (
            <tr key={signup.id} className="hover:bg-white/5">
              <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-white">
                {signup.name}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {signup.email}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {signup.phone}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {new Date(signup.createdAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {midDayReset.length === 0 && (
        <div className="text-center py-16 text-gray-400">
          No signups yet for Mid Day Reset
        </div>
      )}
    </div>
  )
}

export default MidDayResetTab
